import { Suspense } from 'react'
import Field from '../../../../fields'
import EditProfileCard, { CardFields } from '../EditProfileCard'

type EmergencyContactCardProps = {
  fields: Record<string, any>
  formId: string
  testId?: string
}

const EmergencyContactCard = ({
  fields,
  formId,
  testId
}: EmergencyContactCardProps) => (
  <EditProfileCard title="Emergency contact" testId={testId}>
    <Suspense fallback={<div>Loading...</div>}>
      <CardFields>
        <Field
          formId={formId}
          keys={['emergencyContactName.first', 'emergencyContactName.last']}
          label="Emergency Contact"
          placeholders={['First name', 'Last name']}
          type="multiText"
          values={fields}
        />
        <Field
          formId={formId}
          keys="emergencyContactRelation"
          label="Emergency Contact Relation"
          type="text"
          values={fields}
        />
        <Field
          className="emergencynumber-field"
          formId={formId}
          keys="emergencyContactNumber"
          label="Emergency Contact Telephone"
          options={{ phone: true, phoneRegionCode: 'GB' }}
          type="formattedText"
          values={fields}
        />
      </CardFields>
    </Suspense>
  </EditProfileCard>
)

export default EmergencyContactCard
